import classNames from "classnames";
import styles from "./Dropdown.module.scss";
import "./index.css";

type Props = {
  menuList: menuItem[];
  placeholder?: string;
  onChange: (e: any) => void;
  extraClass?: string
};

type menuItem = {
  label: string;
  selected?: boolean,
  value: any
};


//PLACE HOLDER VÄLJ MÅNAD

export default function DropdownElement({
  menuList,
  placeholder,
  onChange,
  extraClass
}: Props) {
  const menuItemElement = menuList.map((item, index) => (
    <option selected={item.selected} className={styles.Option} key={item.value} value={item.value}>
      {item.label}
    </option>
  ));

  return (
    <select onChange={(e) => onChange(e)} className={classNames({
      [styles.Select]: true,
      [extraClass]: extraClass
    })}>
      {placeholder ? (
        <optgroup label={placeholder} defaultValue={placeholder}>
          <option selected disabled hidden>Välj månad</option>
          {menuItemElement}
        </optgroup>
      ) : (
        menuItemElement
      )}
    </select>
  );
}
